/**
 * <CheckboxForCustomField 
 *		// please describe props here
 *	/>
 *
 * This is...
 *
 * @parent anybody
 * @children 
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'

class CheckboxForCustomField extends React.Component {
  constructor(props) {
    super(props);

    this.state = {}
  }

  componentWillMount() {
    this.strValueToArray(this.props.value)    
  }

  componentWillReceiveProps({ value }) {
    if (value) {
      this.strValueToArray(value);
    }
  }

  strValueToArray(strValue = '[]') {
    if(strValue === ''){
      strValue = '[]';
    }

    let value;
    if (typeof strValue == "string") {
      value = JSON.parse(strValue);
    } else if (Array.isArray(strValue)) {
      value = strValue;
    }
    if (!Array.isArray(value)) {
      value = value.split(',');      
      //value = [];
    }

    this.setState({
      value,
    });
  }

  onChange(option) {
    return ()=>{
      let {
        value = [],
      } = this.state;

      const index = value.indexOf(option);

      if (index === -1) {
        value.push(option);
      } else {
        value.splice(index, 1);
      }

      this.props.onChange(JSON.stringify(value));
    }
  }
  
  render() {
    const {
      options = [],
    } = this.props.item;

    const {
      value,
    } = this.state;

    return (
      <div className='CheckboxForCustomField'>
        {options.map((option, key)=>{
          return (
            <div className='form-group' key={key}>
              <label className='control'  >
                <input type='checkbox' value={option} checked={value.indexOf(option) > -1} onClick={this.onChange(option)} />
                <span className='checkmark'></span>
                {option}   
              </label>
            </div>
          );
        })}
      </div>
    )
  }
}

export default CheckboxForCustomField;



// WEBPACK FOOTER //
// ./src/components/UI/CustomField/CheckboxForCustomField.js